"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CollapseItem = _interopRequireDefault(require("./CollapseItem.style"));
var _Collapse = require("../Collapse");
var _excluded = ["classPrefix", "children", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CollapseItem = function CollapseItem(_ref) {
  var classPrefix = _ref.classPrefix,
    children = _ref.children,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_CollapseItem["default"], _extends({
    className: "".concat(classPrefix, "Item ").concat(className)
  }, otherProps), children);
};
CollapseItem.propTypes = {
  /** The html class name */
  classPrefix: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
CollapseItem.defaultProps = {
  classPrefix: _Collapse.COLLAPSE_ROOT_CLASS_NAME,
  className: ''
};
var _default = exports["default"] = CollapseItem;